import { useSearchParams } from 'react-router-dom';
import { STAFF_ID_STORAGE_KEY } from './catalog.js';

export function useStaffIdParam(): string | null {
  const [params] = useSearchParams();
  return params.get('staffId') ?? params.get('id') ?? getStoredStaffId();
}

export function getStoredStaffId(): string | null {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem(STAFF_ID_STORAGE_KEY);
}

export function setStoredStaffId(staffId: string): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(STAFF_ID_STORAGE_KEY, staffId);
}

export function staffListPath(): string {
  return '/staff-list';
}

export function inviteStaffPath(): string {
  return '/invite-staff';
}

export function staffDetailPath(staffId: string): string {
  return `/staff-detail?staffId=${encodeURIComponent(staffId)}`;
}

export function pinSignInPath(): string {
  return '/pin-sign-in';
}
